import api from './client'

/** STOCK → Fotos pendientes: foto + ficha buscadas por código de barras, e importador de EANs. */
export const candidatosEanApi = {
  listar: () => api.get('/candidatos-ean'),
  buscar: (ean) => api.post('/candidatos-ean/buscar', { ean }),
  buscarSkus: (skus) => api.post('/candidatos-ean/buscar-skus', { skus }),
  importar: (archivo, confirmar) => {
    const fd = new FormData()
    fd.append('archivo', archivo)
    fd.append('confirmar', confirmar ? '1' : '0')
    return api.post('/candidatos-ean/importar', fd, { timeout: 120000 })
  },
  estadoSku: (sku) => api.get('/candidatos-ean/estado-sku', { params: { sku } }),
  aprobar: (id, sku, foto, ficha) => api.post(`/candidatos-ean/${id}/aprobar`, { sku, foto, ficha }),
  rechazar: (id, motivo) => api.post(`/candidatos-ean/${id}/rechazar`, { motivo }),
}
